import { cloneNodeAndInsertAfterOriginalInGridLayout, deleteContainerFromGridLayout, setNodeStyles } from 'ContentEditorUI/redux/actions/gridsModuleActions';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { HideIcon } from 'foundations-assets/icons/components/HideIcon';
// @ts-ignore not typed
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
export function useGridToggleNodeVisibilityOnThisBreakpoint(toolbarInfo) {
  const dispatch = useDispatch();
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  return useCallback((isHidden, e) => {
    if (e) {
      e.stopPropagation();
    }
    if (!toolbarInfo) {
      return;
    }
    dispatch(setNodeStyles(toolbarInfo.id, toolbarInfo.gridLayoutId, false, activeBreakpointName, {
      isHidden: !isHidden
    }));
  }, [dispatch, activeBreakpointName, toolbarInfo]);
}
export const buildEditStylesAction = (type, dispatch, toolbarInfo, label) => {
  return {
    id: `${type}-styles`,
    icon: EditIcon,
    menuLabel: label,
    tooltipLabel: label,
    placement: 'top left',
    callback: () => {
      if (toolbarInfo !== null && toolbarInfo !== void 0 && toolbarInfo.id) {
        dispatch(updateSelectedItem(toolbarInfo.id, {
          containerId: toolbarInfo.gridLayoutId
        }));
      }
    }
  };
};
export const buildDuplicateAction = (type, dispatch, toolbarInfo, label) => {
  return {
    id: `${type}-duplicate`,
    icon: DuplicateIcon,
    menuLabel: label,
    menuTooltip: label,
    tooltipLabel: label,
    callback: () => {
      if (toolbarInfo !== null && toolbarInfo !== void 0 && toolbarInfo.id) {
        dispatch(cloneNodeAndInsertAfterOriginalInGridLayout(toolbarInfo.gridLayoutId, toolbarInfo.id));
      }
    },
    placement: 'top left'
  };
};
export const buildDeleteAction = (type, dispatch, toolbarInfo, label) => {
  return {
    id: `${type}-delete`,
    icon: DeleteIcon,
    menuLabel: label,
    tooltipLabel: label,
    callback: () => {
      if (toolbarInfo !== null && toolbarInfo !== void 0 && toolbarInfo.id) {
        dispatch(deleteContainerFromGridLayout(toolbarInfo.gridLayoutId, toolbarInfo.id));
      }
    },
    placement: 'top left'
  };
};
export const buildHideOnMobileAction = (type, label, toggleNodeVisibilityOnThisBreakpoint) => {
  return {
    id: `${type}-hide`,
    icon: HideIcon,
    menuLabel: label,
    tooltipLabel: label,
    callback: e => {
      // bus?.dispatchActionToEventBus(
      //   logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.HIDE_GRID)
      // );
      if (e) {
        toggleNodeVisibilityOnThisBreakpoint(false, e);
      }
    },
    onlyInDropdown: false
  };
};